import { 
    postData, getData
} from '@/store/config/method'

const itemInit = {
    "video-profil": null,
    "ikatan-alumni-masehi-kudus": null,
    "profil-yayasan": null,
    "telepon": null,
    "fax": null,
    "email": null,
}

const initialState = () => ({
    message: null,
    status: 0,
    item: {...itemInit},
    data: {
        "video-profil": null,
        "ikatan-alumni-masehi-kudus": null,
        "profil-yayasan": null,
        "telepon": null,
        "fax": null,
        "email": null,
    },
})
const state = initialState
 
const getters = {
    getMessage: state => state.message,
    getStatus: state => state.status,
    getVideoProfil: state => state.data['video-profil'],
    getIkamaku: state => state.data['ikatan-alumni-masehi-kudus'],
    getFoundationProfile: state => state.data['profil-yayasan'],
    getPhone: state => state.data['telepon'],
    getFax: state => state.data['fax'],
    getEmail: state => state.data['email'],
    getItem: state => (key) => state.item[key]
}

const actions = {
    setItem({commit}, {value,key}){
        commit('SET_ITEM', {value,key})
    },
    setData({commit}, {value,key}){
        commit('SET_DATA', {value,key})
    },
    async submit({
        commit
    }, payload) {
        try {
            const response = await postData('api','/management/setting',payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchData({
        commit
    },key){
        try {
            const url = `/management/setting/key/${key}`
            const response = await getData('api',url);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA', {value: response.data.data?.value || null, key});
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    resetState({commit}){
        commit('resetState')
    }
}

const mutations = {
    SET_FAILED(state) {
        state.message = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MESSAGE(state, error) {
        if(error.status == 400){
            state.message = error.data.message
            state.status = error.data.status
        }else{
            state.message = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_RESPONSE(state, response) {
        state.message = response.message
        state.status = response.status
    },
    SET_DATA(state, {value, key}) {
        state.data[key] = value
    },
    SET_ITEM(state, {value, key}) {
        state.item[key] = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}